import { Box } from '@mui/material';
import type { DriverType } from '@repo/supergraph/marketplace/types';
import { CDDriverList } from '../../components/CDDriverList';
import { DriverContent } from '../../components/DriverContent';

type DriverCell = DriverType | DriverType[];

type Props = {
  cell: DriverCell;
  groupIndex: number;
  columnIndex: number;
  driversLength: number;
};

export function DriverTableCell({ cell, groupIndex, columnIndex, driversLength }: Props) {
  const isCdApyGroup = Array.isArray(cell);

  return (
    <Box
      sx={{
        gridColumn: columnIndex + 1,
        gridRow: groupIndex + 4,
        display: 'flex',
        flexDirection: 'column',
        borderLeft: columnIndex === 0 ? '0px' : '1px solid',
        borderLeftColor: columnIndex === 0 ? 'transparent' : 'neutral.lighter',
      }}
    >
      {cell && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            px: 2,
            py: '1rem',
            minHeight: '100px',
            height: '100%',
            justifyContent: 'center',
          }}
        >
          {isCdApyGroup ? (
            <CDDriverList drivers={cell} variant="table" />
          ) : (
            <DriverContent driver={cell} variant="grid" />
          )}
        </Box>
      )}

      {groupIndex < driversLength - 1 ? (
        <Box sx={{ borderBottom: '1px solid', borderColor: 'neutral.lighter' }} />
      ) : null}
    </Box>
  );
}
